angular.module('admin.menus', [
  'admin.menus.index',
  'admin.menus.tree'
]);


// WEBPACK FOOTER //
// ./client/src/app/admin/menus/index.js